/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';

import { Icon } from '../../../ui/Icon';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.style';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export class ContentBlock extends SafePureComponent {
  constructor(props) {
    super(props);
  }
  renderCTA = CTA => {
    return (
      <a href={CTA.link}>
        <span>{CTA.text}</span>
        <span>
          <Icon name="chevron-right" />
        </span>
      </a>
    );
  };

  safeRender() {
    const { icon, title, desc, CTA1, CTA2, textColor } = this.props;
    return (
      <React.Fragment>
        <div
          css={[styles.itemsBoxCss, styles.getHighlightTxt(textColor)]}
          className="leftseccontent"
        >
          {icon && <img src={icon} alt="banner img" />}
          <RichText field={{ value: title, editable: false }} tag="h2" />
          {desc && <p>{desc}</p>}
          <div className="findoutlink">
            {this.renderCTA(CTA1)}
            {this.renderCTA(CTA2)}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ContentBlock.displayName = 'Shop/ContentBlock';

export default withNamespaces()(ContentBlock);
